import { render, staticRenderFns } from "./AquassistManage.vue?vue&type=template&id=bda5dfe4&scoped=true"
import script from "./AquassistManage.vue?vue&type=script&lang=js"
export * from "./AquassistManage.vue?vue&type=script&lang=js"
import style0 from "./AquassistManage.vue?vue&type=style&index=0&id=bda5dfe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda5dfe4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
